// @flow
import React from 'react';
import { Button } from '@finect/tabular-core/Button';
import { Section } from '@finect/tabular-core/Section';
import { Small } from '@finect/tabular-core/Small';
import { NewSectionInner } from './NewSection';
import { SectionTitle } from './Titles';
import { CTA } from './CTA';
// import { ArticleCTA } from './';

type Props = {
  toggleModal: Function,
  white?: boolean
};

export const BottomCTA = ({ toggleModal, white }: Props) => (
  <Section color={white ? '' : 'grey'} textAlign="center">
    <NewSectionInner>
      <SectionTitle
        title="Da el primer paso"
        subtitle={<>Busquemos tu <b>asesor financiero</b> ideal: alguien que te ayude a cumplir tus metas de inversión y a conseguir la tranquilidad financiera con la que todos soñamos.</>}
        maxWidth
      />
      <CTA>
        <Button onClick={() => toggleModal()}>Busca un asesor financiero</Button>
        <Small display="block" textAlign="center" margin="6px 0 0" light>
          La búsqueda de un asesor es 100% gratuita.
        </Small>
      </CTA>
      {/* <ArticleCTA toggleModal={toggleModal} /> */}
    </NewSectionInner>
  </Section>
);
